const DEFAULT_MARQUEE_DURATION = 108;
const FALLBACK_MARQUEE_SPEED = 90;

function getTrackDistance(track) {
    return track.scrollWidth / 2;
}

function applyMarqueeSpeed() {
    const tracks = Array.from(document.querySelectorAll('.marquee__track'));

    if (!tracks.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const referenceDistance = getTrackDistance(tracks[0]);
    const speed = referenceDistance > 0 ? referenceDistance / DEFAULT_MARQUEE_DURATION : FALLBACK_MARQUEE_SPEED;

    tracks.forEach((track) => {
        const distance = getTrackDistance(track);

        if (!distance) {
            return;
        }

        track.style.setProperty('--marquee-duration', `${distance / speed}s`);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    applyMarqueeSpeed();

    let resizeFrame = null;

    window.addEventListener('resize', () => {
        if (resizeFrame) {
            window.cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = window.requestAnimationFrame(() => {
            applyMarqueeSpeed();
            resizeFrame = null;
        });
    });

    window.addEventListener('load', applyMarqueeSpeed, { once: true });

    if (document.fonts && typeof document.fonts.ready?.then === 'function') {
        document.fonts.ready.then(applyMarqueeSpeed);
    }
});